import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import Typography from '@material-ui/core/Typography';
import store from '../../redux/store.js';
import { COLORS2 } from '../../constants.js';
import TouchEnabledIcon from '../icons/TouchEnabledIcon.js';
import TouchDisabledIcon from '../icons/TouchDisabledIcon.js';
import VBToolTip from '../Tooltip/VBToolTip.js';
import { setCallbackForTouchPointer, shouldIgnoreTouch, updateIgnoreTouch } from '../../common/storageFeatures.js';
import { DialogTitle, makeStyles } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(() => ({
    mainContainer: {
        paddingLeft: '16px', display: 'flex', paddingRight: '16px', paddingTop: '8px', paddingBottom: '8px',
    },
    selectedOption: {
        cursor: 'pointer',
        textAlign: 'center',
        width: '50%',
        borderWidth: '1px',

        borderStyle: 'solid',
        borderRadius: '4px',
        boxShadow: '0 0 0 2px #07767D33',
        borderColor: '#07767D',
        margin: '0.1rem',
        padding: '0.2rem',
    },
    unSelectedOption: {
        cursor: 'pointer',
        textAlign: 'center',
        width: '50%',
        borderWidth: '1px',

        borderStyle: 'solid',
        borderRadius: '4px',
        boxShadow: '0 0 0 2px #07767D10',
        borderColor: '#FFFFFF22',
        '&:hover': {
            borderColor: '#07767D77',
        },
        margin: '0.1rem',
        padding: '0.2rem',
    },
    icon: {
        color: COLORS2.virtualGreen, width: '32px', height: '32px',
    },
    iconLage: {
        color: COLORS2.virtualGreen, width: '64px', height: '64px',
    },
}));

const TouchToggler = () => {

    const [touchEnabled, setTouchEnabled] = useState(true);
    const [openModal, setModalOpened] = useState(false);
    const classes = useStyles();

    useEffect(() => {
        let profile = store.getState().profile;

        if (shouldIgnoreTouch(profile.email)) {
            setTouchEnabled(false);
        } else {
            setTouchEnabled(true);
        }
    }, []);

    const toggleValue = () => {
        let profile = store.getState().profile;
        setTouchEnabled(!touchEnabled);
        updateIgnoreTouch(profile.email, !touchEnabled);
    };

    const enableTouch = () => {
        let profile = store.getState().profile;
        setTouchEnabled(true);
        updateIgnoreTouch(profile.email, false);
    };

    const disableTouch = () => {
        let profile = store.getState().profile;
        setTouchEnabled(false);
        updateIgnoreTouch(profile.email, true);
    };


    const updateDialogOpen = () => {
        setModalOpened(true);
    };

    setCallbackForTouchPointer(updateDialogOpen);

    return (
        <div className={classes.mainContainer}>
            <div className={touchEnabled ? classes.selectedOption : classes.unSelectedOption} onClick={enableTouch}>
                <VBToolTip content={<FormattedMessage id='touchEnabled.tooltip' />}>
                    <div><TouchEnabledIcon className={classes.icon} /></div>
                    <Typography variant={'h6'}><FormattedMessage id={'touchEnabled'} /></Typography>
                </VBToolTip>
            </div>
            <div className={!touchEnabled ? classes.selectedOption : classes.unSelectedOption}
                 onClick={disableTouch}>
                <VBToolTip content={<FormattedMessage id='touchDisabled.tooltip' />}>
                    <div><TouchDisabledIcon className={classes.icon} /></div>
                    <Typography variant={'h6'}><FormattedMessage id={'touchDisabled'} /></Typography>
                </VBToolTip>
            </div>
            <Dialog
                open={openModal}
                onClose={() => {
                    setModalOpened(false);
                }}
            >
                <DialogTitle>
                    <Typography variant={'h4'}>
                        <FormattedMessage id='touchDialog.title' />
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <div>
                        <Typography variant={'h6'}>
                            <FormattedMessage id='touchDialog.description1' />
                        </Typography>
                        <TouchDisabledIcon className={classes.iconLage} />
                    </div>
                    <div>
                        <Typography variant={'h6'}>
                            <FormattedMessage id='touchDialog.description2' />
                        </Typography>

                    </div>

                </DialogContent>
                <DialogActions style={{ marginBottom: '0.5rem', marginRight: '1rem' }}>


                    <Button
                        onClick={() => {
                            disableTouch();
                            setModalOpened(false);
                        }}
                        color='primary'
                        size={'large'}
                    >
                        <FormattedMessage id='touchDisabled' />
                    </Button>

                    <Button
                        onClick={() => {
                            enableTouch();
                            setModalOpened(false);
                        }}
                        color='secondary'
                        size={'large'}
                    >
                        <FormattedMessage id='close' />
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default injectIntl(TouchToggler);
